import { useState, useEffect } from 'react'
import { getPlanos } from '../../../api'

function usePlanos (segmento, credito) {
  const [planos, setPlanos] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function requestPlanos () {
      let itens = await getPlanos(
        segmento,
        credito?.codigoProdutor,
        credito?.codigoBem,
        credito?.valorBem
      )
      setPlanos(itens.data.planos)
    }
    requestPlanos().then(() => {
      setIsLoading(false)
    })
  }, [segmento, credito.codigoBem, credito.codigoProdutor, credito.valorBem])

  const threshold = credito.valorBem * 0.15

  function closeValue(plan){
    if(Math.abs(plan.grupo.valorBem - credito.valorBem) < threshold){
      return plan
    }
  }

  let filteredPlans = planos.filter(closeValue)
  

  return { filteredPlans, planos, isLoading }
}

export default usePlanos
